module.exports = __webpack_public_path__ + "static/img/ticket_verified.bbf37663.png";